import { FC } from "react";

import __ from "web/Layout/Translations";

import WarningIcon from "web/assets/icons/warning-circle.svg";

import classes from "./pointsLoadErrorBanner.scss";

interface IPointsLoadErrorBannerProps {
  isError: boolean;
  refetch: () => void;
}

const PointsLoadErrorBanner: FC<IPointsLoadErrorBannerProps> = ({
  isError,
  refetch,
}) => {
  if (!isError) {
    return null;
  }

  return (
    <div
      className={classes.root}
      role="alert"
      data-t1="points_load_error_banner"
      data-testid="points-load-error-banner"
    >
      <span className={classes.icon} aria-hidden="true">
        <WarningIcon />
      </span>
      <p className={classes.message}>
        <span>{__("Wystąpił problem z załadowaniem treści na stronie. Odśwież stronę.")}</span>
        <button
          type="button"
          className={classes.retry}
          onClick={() => refetch()}
          data-t1="points_load_error_retry"
          data-testid="points-load-error-retry"
        >
          {__("Odśwież stronę")}
        </button>
      </p>
    </div>
  );
};

export default PointsLoadErrorBanner;
